import { render, staticRenderFns } from "./CoreSelection.vue?vue&type=template&id=4d5a0757&"
import script from "./CoreSelection.vue?vue&type=script&lang=js&"
export * from "./CoreSelection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ichigei/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d5a0757')) {
      api.createRecord('4d5a0757', component.options)
    } else {
      api.reload('4d5a0757', component.options)
    }
    module.hot.accept("./CoreSelection.vue?vue&type=template&id=4d5a0757&", function () {
      api.rerender('4d5a0757', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Cores/CoreSelection.vue"
export default component.exports